(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("tcc-i18n"), require("tcc-crate"), require("tcc-fds"));
	else if(typeof define === 'function' && define.amd)
		define("tcc-fds-table", ["react", "tcc-i18n", "tcc-crate", "tcc-fds"], factory);
	else if(typeof exports === 'object')
		exports["tcc-fds-table"] = factory(require("react"), require("tcc-i18n"), require("tcc-crate"), require("tcc-fds"));
	else
		root["tcc-fds-table"] = factory(root["react"], root["tcc-i18n"], root["tcc-crate"], root["tcc-fds"]);
})(self, (__WEBPACK_EXTERNAL_MODULE__9155__, __WEBPACK_EXTERNAL_MODULE__9249__, __WEBPACK_EXTERNAL_MODULE__4568__, __WEBPACK_EXTERNAL_MODULE__7996__) => {
return 